module.exports = __webpack_public_path__ + "img/banner1.c01862d4.jpg";